import router from '@/router'
import {
  // getAnalyzeHandsFilter,
  // getAnalyzeHandsFilterV2,
  // getPracticeHandsFilter,
  // getPracticeSessionsFilter,
  // getPracticeStatsFilter,
  // getReportsFlopFilter,
  // getDrillsFilter,
  // getSavedFiltersFilter,
  // getSavedSpotsFilter,
  // getSavedTreesFilter,
  // getSavedRangesFilter,
  // getSavedSolutionsFilter,
  // getCustomSolutionsFilter,
  // getCustomSolutionsFilter,
  getFilterBase,
} from '@/store/tableFilters/tableFilters'
import { sanitizeQuery } from '@/store/router/router'

const getInitialState = () => {
  const res = {
    // ffahv2: getAnalyzeHandsFilterV2().query,
    // ffah: getAnalyzeHandsFilter().query,
    // ffph: getPracticeHandsFilter().query,
    // ffps: getPracticeSessionsFilter().query,
    // ffxs: getPracticeStatsFilter().query,
    // ffdf: getDrillsFilter().query,
    // ffrf: getReportsFlopFilter().query,
    // ffsf: getSavedFiltersFilter().query,
    // ffss: getSavedSpotsFilter().query,
    // ffts: getSavedTreesFilter().query,
    // ffsr: getSavedRangesFilter().query,
    // ffcs: getCustomSolutionsFilter().query,

    // -- from new config + rename to support prefix filter_*
    hhv2: getFilterBase(), // anyler v2
    ffxs: getFilterBase(), // practice stats
    ffah: getFilterBase(), // analyze hands
    ffdf: getFilterBase(), // drills
    ffph: getFilterBase(), // practice hands
    ffps: getFilterBase(), // practice sessions
    ffsr: getFilterBase(), // saved ranges
    ffss: getFilterBase(), // saved spots
    ffts: getFilterBase(), // saved trees
    ffcs: getFilterBase(), // custom solutions
    ffsf: getFilterBase(), // saved filters
    ffrf: getFilterBase(), // reports flop
  }
  return res
}

const getters = {
  hhv2: state => state.hhv2,
  ffxs: state => state.ffxs,
  // rrkk: state => state.rrkk,
  ffps: state => state.ffps,
  ffah: state => state.ffah,
  ffdf: state => state.ffdf,
  ffph: state => state.ffph,
  ffcs: state => state.ffcs,
  ffsr: state => state.ffsr,
  ffsf: state => state.ffsf,
  ffrf: state => state.ffrf,
  ffss: state => state.ffss,
  ffts: state => state.ffts,

  // filters_analyze_hands: state => state.ffah,
  // filters_analyze_hands_v2: state => state.ffahv2,
  // filters_practice_hands: state => state.ffph,
  // filters_practice_sessions: state => state.ffps,
  // // filters_reports_flop: state => state.ffrf,
  // filters_drills: state => state.ffdf,
  // filters_saved_filters: state => state.ffsf,
  // filters_saved_spots: state => state.ffss,
  // filters_saved_trees: state => state.ffts,
  // filters_saved_ranges: state => state.ffsr,
  // filters_custom_solutions: state => state.ffcs,
  // filters_get_api_filter_params: state => tbf_conf => {
  //   const params = state[tbf_conf.id]
  //   let res = JSON.parse(JSON.stringify(params))
  //   Object.keys(params).forEach(key => {
  //     let val = res[key]
  //     if (['favorite', 'marked'].includes(key)) {
  //       if (!val) {
  //         delete res[key]
  //       }
  //     } else if (typeof val === 'boolean' ? !val : val === 0 ? false : !val ? true : !val?.length) {
  //       delete res[key]
  //     }
  //   })
  //   if (tbf_conf.getApiTransform) {
  //     res = tbf_conf.getApiTransform(res)
  //   }
  //   // console.log(res)
  //   return res
  // },
}

const actions = {
  // table_filters_initialize({ state, commit, dispatch, getters }) {
  //   const res = {
  //     ffah: getAnalyzeHandsFilter().query,
  //     ffahv2: getAnalyzeHandsFilterV2().query,
  //     ffph: getPracticeHandsFilter().query,
  //     ffps: getPracticeSessionsFilter().query,
  //     ffrf: getReportsFlopFilter().query,
  //     ffdf: getDrillsFilter().query,
  //     // edit:null
  //   }
  //   state = res
  // },
  filters_apply({ state, commit, dispatch, getters }, { id, value, conf }) {
    commit('filters_apply', { id, value })

    if (conf?.noUrlUpdate) return
    if (conf?.hasNoUrlUpdate) return

    let query = {}
    Object.keys(value).forEach(kk => {
      query[`${id}_${kk}`] = value[kk]
    })

    const currentQuery = router.currentRoute.value.query
    query = { ...currentQuery, ...query }
    query = sanitizeQuery(query)
    router.push({ query }).catch(() => {})
  },
}

const mutations = {
  filters_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  filters_set(state, { key, value }) {
    state[key] = value
  },
  filters_apply(state, { id, value }) {
    const res = {
      ...state[id],
      ...value,
    }
    Object.keys(res).forEach(key => {
      if (!res[key]?.length) {
        delete res[key]
      }
    })
    state[id] = res
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
